var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1L4.5 1ZM3.64645 11.8536C3.84171 12.0488 4.15829 12.0488 4.35355 11.8536L7.53553 8.67157C7.7308 8.47631 7.7308 8.15973 7.53553 7.96447C7.34027 7.7692 7.02369 7.7692 6.82843 7.96447L4 10.7929L1.17157 7.96447C0.976311 7.7692 0.659728 7.7692 0.464466 7.96447C0.269204 8.15973 0.269204 8.47631 0.464466 8.67157L3.64645 11.8536ZM3.5 1L3.5 11.5H4.5L4.5 1L3.5 1Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.61fa9c5551e5e66b3fb1f325eeeb2741.svg";
export { ForwardRef as ReactComponent };